import React, {useEffect, useState} from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheckSquare, faSquare} from "@fortawesome/free-regular-svg-icons";

import {Pagination} from "../../../common/table/pagination/Pagination";
import {StandardButton} from "../../../common/button/standard-button/StandardButton";

export const TrainingCaptureModal = ({trainingModuleList, setTrainingModuleList, onUpdateClick}) => {

    const [trainingModulePages, setTrainingModulePages] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);

    useEffect(() => {
        let copyOfTrainingModuleList = JSON.parse(JSON.stringify(trainingModuleList));
        const filteredTrainingModuleList = copyOfTrainingModuleList.filter(trainingModule => trainingModule.active);
        const pages = [];
        while (filteredTrainingModuleList.length) {
            pages.push(filteredTrainingModuleList.splice(0, 7));
        }
        setTrainingModulePages([...pages]);
    }, [trainingModuleList]);

    const handleTrainingModuleClick = (selectedTrainingModule) => {
        const copyOfTrainingModuleList = JSON.parse(JSON.stringify(trainingModuleList));
        copyOfTrainingModuleList.forEach((trainingModule) => {
            if (trainingModule.externalReference === selectedTrainingModule.externalReference) {
                trainingModule.isSelected = !trainingModule.isSelected;
            }
        });
        setTrainingModuleList([...copyOfTrainingModuleList]);
    }

    const buildList = () => {
        return trainingModulePages[currentPage].map((trainingModule) => {
            return (
                <div className="capture-modal-list-item" key={trainingModule.externalReference}>
                    <div className="capture-modal-list-item-text">{trainingModule.trainingModule}</div>
                    <div className="capture-modal-list-item-icon-container">
                        {trainingModule.isSelected &&
                        <FontAwesomeIcon className="capture-modal-list-item-icon" icon={faCheckSquare}
                                         onClick={() => {
                                             handleTrainingModuleClick(trainingModule)
                                         }}/>}
                        {!trainingModule.isSelected &&
                        <FontAwesomeIcon className="capture-modal-list-item-icon" icon={faSquare}
                                         onClick={() => {
                                             handleTrainingModuleClick(trainingModule)
                                         }}/>}
                    </div>
                </div>
            );
        });
    }

    let listItems;
    if (trainingModulePages.length > 0) {
        listItems = buildList();
    }

    return (
        <div className="capture-modal-container">
            <div className="capture-modal-list-header-container">
                <p className="capture-modal-list-header-one">Training Module</p>
                <p className="capture-modal-list-header-two">Provided</p>
            </div>
            <div className="capture-modal-list-items-container">
                {listItems}
            </div>
            <Pagination currentPage={currentPage} setCurrentPage={setCurrentPage}
                        pageCount={trainingModulePages.length}/>
            <div className="capture-modal-button-container">
                <StandardButton text="Update" onClick={onUpdateClick}/>
            </div>
        </div>
    );
}
